import SinglePropChainTracker from "../../../prop-tracker-utils/single-prop-chain-tracker.js";

import ContentTrackerController from "./labels/content-tracker-controller.js";
import PositionTrackerController from "./labels/position-tracker-controller.js";
import VisibilityTrackerController from "./labels/visibility-tracker-controller.js";

class LabelProperties {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx, { visibilityController, positionController, contentController }) {
        this._evtCtx = evtCtx;

        this._contentDataTracker = new SinglePropChainTracker(evtCtx);
        this._posDataTracker = new SinglePropChainTracker(evtCtx);
        this._visDataTracker = new SinglePropChainTracker(evtCtx);

        this._contentTrackCtrl = new ContentTrackerController(evtCtx, contentController);
        this._positionTrackCtrl = new PositionTrackerController(evtCtx, positionController);
        this._visibilityTrackCtrl = new VisibilityTrackerController(evtCtx, visibilityController);
    }

    trackContent(contentData) {
        this._contentDataTracker.track(contentData && contentData.data, ["value"]);
    }

    trackPositions(posData) {
        this._posDataTracker.track(posData && posData.data, ["value"]);
    }

    trackVisibility(visData) {
        this._visDataTracker.track(visData && visData.data, ["value"]);
    }

    trackLabels(labels) {
        if (labels) {
            this._contentTrackCtrl.trackLabels(labels.data, labels.events);
            this._positionTrackCtrl.trackLabels(labels.data, labels.events);
            this._visibilityTrackCtrl.trackLabels(labels.data, labels.events);
        } else {
            this._contentTrackCtrl.trackLabels();
            this._positionTrackCtrl.trackLabels();
            this._visibilityTrackCtrl.trackLabels();
        }
    }

    update() {
        this._contentDataTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._contentTrackCtrl.trackContent(newValue, newValue ? this._evtCtx.getEvents(newValue) : null);
        });

        this._posDataTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._positionTrackCtrl.trackPositions(newValue, newValue ? this._evtCtx.getEvents(newValue) : null);
        });

        this._visDataTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._visibilityTrackCtrl.trackVisibility(newValue, newValue ? this._evtCtx.getEvents(newValue) : null);
        });

        this._contentTrackCtrl.update();
        this._positionTrackCtrl.update();
        this._visibilityTrackCtrl.update();
    }
}

export default LabelProperties;
